import { useCustomer } from "@/modules/clients/hooks/use-customer.hook";
import { Box } from "@mui/material";
import NawyNowTab from "./nawy-now-tab";

/**
 * Lead-page host for the Nawy Now tab. The customer lookup (crm-backend) only enriches
 * the board — persona matching by phone and the start-flow card. Case resolution runs
 * without waiting on it; the board fetch itself waits for the lookup to settle
 * (clientReady) so the first request already carries the phones — see useWorkflowBoard.
 */
const LeadNawyNowTab = ({
  customerUId,
  leadUid,
  journeyUid,
  isNawyNowLead,
}: {
  customerUId?: string;
  leadUid?: string;
  journeyUid?: string;
  /** §NawyNowGate: the host layout's lead-type verdict — gates the start-flow card. */
  isNawyNowLead?: boolean;
}) => {
  const { data: client, isFetched: clientFetched } = useCustomer({
    uid: customerUId,
  });

  return (
    // §Overflow (Safari): `contain: inline-size` stops the tab's intrinsic width from propagating
    // into the lead page's column layout. With 11 phases the stepper's min-content width (~1.5k px)
    // exceeds most viewports; Chrome lets the inner `overflow-x: auto` absorb it, but WebKit sizes
    // the surrounding grid column by min-content FIRST — the page grew a horizontal scrollbar and
    // the left lead panel was pushed off-screen. Containment makes the tab take exactly the width
    // its column offers, so the stepper's own scroller actually engages.
    <Box sx={{ height: "100%", overflowY: "auto", minWidth: 0, contain: "inline-size" }}>
      {/* customerUid passed straight from the lead (known synchronously) — client is
          async enrichment only, and phone-edit routing must never wait on it */}
      <NawyNowTab
        client={client}
        clientReady={!customerUId || clientFetched}
        leadUid={leadUid}
        journeyUid={journeyUid}
        customerUid={customerUId}
        isNawyNowLead={isNawyNowLead}
      />
    </Box>
  );
};

export default LeadNawyNowTab;
